<template>
  <v-row v-scroll="onScroll">
    <!-- header -->
    <mini-header title="Crear documento" :dense="true" :breadcrumbs="breadcrumbs" :hiddenTab="true" :addPadding="true" :scroll="scroll" />
    <!-- end header -->
    <v-col v-if="!$helpers.hasSomePermission(['add_document'])" class="mt-20">
      <PermissionDenied />
    </v-col>
    <v-col v-else class="mt-20 pa-0" style="z-index:0">
      <v-col cols="12" class="pb-8 px-0">

        <!-- 1. INFORMACIÓN DEL DOCUMENTO -->
        <v-expansion-panels v-model="panelInf" :accordion="false">
          <v-expansion-panel>
            <v-expansion-panel-header class="px-5 py-8">
              <v-row no-gutters align="center">
                <v-col class="pa-0">
                  <span class="subtitle-2 grey-700--text font-weight-bold d-flex align-center"><v-icon class="mr-2" size="18" color="grey-700">mdi-information-outline</v-icon>Información del documento</span>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-7 pb-8">
              <v-list class="transparent pa-0 pe-general-fields">
                <v-row>
                  <v-col cols="12" sm="6" md="4" lg="4" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Tipo de documento</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-autocomplete
                            v-model="documents.document_type"
                            :error="$v.documents.document_type.$error"
                            placeholder="Selecciona un tipo de documento"
                            :items="documentTypeOptions"
                            item-value="id"
                            item-text="name"
                            :menu-props="{ overflowY: true, transition: 'slide-y-transition' }"
                            height="40"
                            single-line
                            outlined
                            dense
                            hide-details
                            append-icon="mdi-chevron-down"
                          >
                            <template v-slot:item="data">
                              <v-list-item-title class="font-weight-regular">{{data.item.name}} ({{data.item.id.replace(/^[A-Z]{2}/, '')}})</v-list-item-title>
                            </template>
                            <template v-slot:selection="data">
                              <v-list-item-title class="grey-500--text py-1" style="min-width: 220px !important">{{data.item.name}} ({{data.item.id.replace(/^[A-Z]{2}/, '')}})</v-list-item-title>
                            </template>
                          </v-autocomplete>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="2" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Tipo de operación <span class="caption grey-300--text" style="line-height: inherit;">(Cat.51)</span></v-list-item-title>
                        <v-list-item-subtitle>
                          <v-autocomplete
                            v-model="documents.operation_type"
                            :items="operationTypes"
                            item-value="value"
                            item-text="description"
                            placeholder="Selecciona un tipo de operación"
                            :menu-props="{ overflowY: true, transition: 'slide-y-transition' }"
                            height="40"
                            single-line
                            outlined
                            dense
                            hide-details
                            append-icon="mdi-chevron-down"
                          >
                            <template v-slot:item="data">
                              <v-list-item-title class="font-weight-regular">{{data.item.description}} ({{data.item.value}})</v-list-item-title>
                            </template>
                            <template v-slot:selection="data">
                              <v-list-item-title class="grey-500--text py-1" style="min-width: 220px !important">{{data.item.description}} ({{data.item.value}})</v-list-item-title>
                            </template>
                          </v-autocomplete>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="2" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Moneda</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-select v-model="documents.currency" :items="currencyOptions" outlined single-line hide-details dense />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="2" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Fecha de emisión</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-menu v-model="menuIssueDate" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition" max-width="290">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field :value="formatDateDisplay(documents.date)" :error="$v.documents.date.$error" v-bind="attrs" v-on="on" append-icon="mdi-calendar-blank" placeholder="dd-mm-aaaa" outlined single-line dense readonly hide-details />
                            </template>
                            <v-date-picker v-model="documents.date" @input="menuIssueDate=false" no-title :first-day-of-week="1" type="date" locale="es" max-width="290" color="blue-500">
                              <v-row class="mb-2 px-6" align="center" justify="end">
                                <v-btn class="body-1" :ripple="false" text color="blue-500" @click="documents.date=''; menuIssueDate=false">Limpiar</v-btn>
                                <v-spacer />
                                <v-btn @click="documents.date=new Date().toISOString().slice(0,10); menuIssueDate=false" color="blue-500">Hoy</v-btn>
                              </v-row>
                            </v-date-picker>
                          </v-menu>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="2" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Hora de emisión</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-menu v-model="menuIssueTime" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="documents.time" outlined single-line dense hide-details readonly v-bind="attrs" v-on="on" append-icon="mdi-clock-outline" placeholder="HH:MM:SS" />
                            </template>
                            <v-time-picker v-model="documents.time" @click:minute="menuIssueTime = false" format="24hr" use-seconds color="blue-500" class="compact-time-picker" />
                          </v-menu>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
                <v-row class="mt-n2">
                  <v-col cols="12" sm="6" md="4" lg="3" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Serie-Correlativo</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field v-model="documents.number" :error="$v.documents.number.$error" :placeholder="seriePlaceholder" outlined single-line hide-details dense />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Forma de pago</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-radio-group v-model="documents.payment_method" row hide-details class="ma-0 pa-0 pt-2 no-radio-hover">
                            <v-radio label="Contado" value="Contado" :ripple="false" />
                            <v-radio label="Crédito" value="Credito" :disabled="!isFactura" :ripple="false" />
                          </v-radio-group>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="2" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Fecha vencimiento <v-chip v-if="!esCredito" class="ml-1 pa-2 caption grey-700--text" x-small color="grey-background">Opcional</v-chip></v-list-item-title>
                        <v-list-item-subtitle>
                          <v-menu v-model="menuDueDate" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition" max-width="290">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field :value="formatDateDisplay(documents.due_date)" :error="$v.documents.due_date.$error" v-bind="attrs" v-on="on" append-icon="mdi-calendar-blank" placeholder="dd-mm-aaaa" outlined single-line dense readonly hide-details />
                            </template>
                            <v-date-picker v-model="documents.due_date" @input="menuDueDate=false" no-title :first-day-of-week="1" type="date" locale="es" max-width="290" color="blue-500">
                              <v-row class="mb-2 px-6" align="center" justify="end">
                                <v-btn class="body-1" :ripple="false" text color="blue-500" @click="documents.due_date=''; menuDueDate=false">Limpiar</v-btn>
                                <v-spacer />
                                <v-btn @click="documents.due_date=new Date().toISOString().slice(0,10); menuDueDate=false" color="blue-500">Hoy</v-btn>
                              </v-row>
                            </v-date-picker>
                          </v-menu>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="2" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Identificador interno <v-chip class="ml-1 pa-2 caption grey-700--text" x-small color="grey-background">Opcional</v-chip></v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field v-model="documents.internal_id" placeholder="Ej: OC-2026-0045" outlined single-line hide-details dense />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="2" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Código local anexo</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field v-model="documents.agency_branch_id" placeholder="0000" maxlength="4" outlined single-line hide-details dense />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
                <v-row class="mt-n2">
                  <v-col cols="12" sm="8" md="6" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Glosa / Observación <v-chip class="ml-1 pa-2 caption grey-700--text" x-small color="grey-background">Opcional</v-chip></v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field v-model="documents.glosa" placeholder="Observaciones del comprobante" outlined single-line hide-details dense />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- 2. INFORMACIÓN DEL RECEPTOR -->
        <v-expansion-panels v-model="panelRec" :accordion="false" class="mt-5">
          <v-expansion-panel>
            <v-expansion-panel-header class="px-5 py-8">
              <v-row no-gutters align="center">
                <v-col class="pa-0">
                  <span class="subtitle-2 grey-700--text font-weight-bold d-flex align-center">
                    <v-icon class="mr-2" size="18" color="grey-700">mdi-account-outline</v-icon>Información del receptor
                    <v-chip v-if="isBoleta" class="ml-3 spot-chip" x-small>N° doc. y nombre obligatorios si importe &gt; S/ 700</v-chip>
                  </span>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-7 pb-8">
              <v-list class="transparent pa-0">
                <v-row>
                  <v-col cols="3" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Tipo de documento</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-autocomplete
                            v-model="documents.customer.tax_id_type"
                            :items="receptorDocTypes"
                            item-value="val"
                            item-text="description"
                            placeholder="Selecciona el tipo"
                            :menu-props="{ overflowY: true, transition: 'slide-y-transition' }"
                            height="40"
                            single-line
                            outlined
                            dense
                            hide-details
                            append-icon="mdi-chevron-down"
                          >
                            <template v-slot:item="data">
                              <v-list-item-title class="font-weight-regular">{{data.item.description}} ({{data.item.val}})</v-list-item-title>
                            </template>
                            <template v-slot:selection="data">
                              <v-list-item-title class="grey-500--text py-1" style="min-width: 220px !important">{{data.item.description}} ({{data.item.val}})</v-list-item-title>
                            </template>
                          </v-autocomplete>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="3" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">N° de documento</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-menu v-model="customerMenu" :close-on-content-click="false" max-width="400px" offset-y bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="documents.customer.tax_id"
                                @input="handleTaxIdInput"
                                :error="$v.documents.customer.tax_id.$error"
                                :loading="customerLoading ? 'blue-500' : false"
                                :placeholder="isBoleta ? 'DNI 8 dígitos' : 'RUC 11 dígitos'"
                                outlined
                                single-line
                                hide-details
                                dense
                                @focus="handleCustomerFocus"
                                @blur="handleCustomerBlur"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <template v-if="customerList.length > 0" v-slot:append>
                                  <v-icon size="20" color="grey-700">mdi-chevron-down</v-icon>
                                </template>
                              </v-text-field>
                            </template>
                            <v-list v-if="customerList.length > 0" max-height="300" style="overflow-y: auto;">
                              <div
                                v-for="customer in customerList"
                                :key="customer.tax_id"
                                @click="selectCustomer(customer)"
                                @mousedown.prevent
                                style="cursor: pointer;"
                                class="d-block px-3 py-2"
                              >
                                <div class="grey-500--text body-2">{{ `${customer.tax_id ?? ''} • ${customer.name ?? ''}` }}</div>
                              </div>
                            </v-list>
                            <v-list v-else-if="documents.customer.tax_id && documents.customer.tax_id.length >= 3">
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title class="grey-500--text py-1">No se encontraron clientes</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="6" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Razón social / Nombre</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field v-model="documents.customer.name" :error="$v.documents.customer.name.$error" outlined single-line hide-details dense />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
                <v-row class="mt-n2">
                  <v-col cols="6" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Dirección <v-chip class="ml-1 pa-2 caption grey-700--text" x-small color="grey-background">Opcional</v-chip></v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field v-model="documents.customer.address" outlined single-line hide-details dense />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="6" class="px-2 py-0">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Ciudad <v-chip class="ml-1 pa-2 caption grey-700--text" x-small color="grey-background">Opcional</v-chip></v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field v-model="documents.customer.city" outlined single-line hide-details dense />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- 3. REFERENCIA (solo NC/ND) -->
        <v-expansion-panels v-if="isNota" v-model="panelRef" :accordion="false" class="mt-5">
          <v-expansion-panel>
            <v-expansion-panel-header class="px-5 py-8">
              <v-row no-gutters align="center">
                <v-col class="pa-0">
                  <span class="subtitle-2 grey-700--text font-weight-bold d-flex align-center"><v-icon class="mr-2" size="18" color="grey-700">mdi-link-variant</v-icon>Documento de referencia (origen)</span>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-7 pb-8">
              <v-list class="transparent pa-0">
                <v-row>
                  <v-col cols="2" class="pa-0 mx-2">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Tipo doc. origen</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-autocomplete
                            v-model="documents.adjustment_note.reference_type"
                            :items="ncRefTypes"
                            :error="$v.documents.adjustment_note.reference_type.$error"
                            item-value="value"
                            item-text="description"
                            placeholder="Selecciona el tipo"
                            :menu-props="{ overflowY: true, transition: 'slide-y-transition' }"
                            height="40"
                            single-line
                            outlined
                            dense
                            hide-details
                            append-icon="mdi-chevron-down"
                          >
                            <template v-slot:item="data">
                              <v-list-item-title class="font-weight-regular">{{data.item.description}} ({{data.item.value}})</v-list-item-title>
                            </template>
                            <template v-slot:selection="data">
                              <v-list-item-title class="grey-500--text py-1" style="min-width: 120px !important">{{data.item.description}} ({{data.item.value}})</v-list-item-title>
                            </template>
                          </v-autocomplete>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="2" class="pa-0 mx-2" style="max-width:120px;">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Serie origen</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field v-model="documents.adjustment_note.reference_serial" :error="$v.documents.adjustment_note.reference_serial.$error" placeholder="F001" outlined single-line hide-details dense />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="2" class="pa-0 mx-2" style="max-width:140px;">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Correlativo origen</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field v-model="documents.adjustment_note.reference_number" :error="$v.documents.adjustment_note.reference_number.$error" placeholder="00000001" outlined single-line hide-details dense />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="2" class="pa-0 mx-2" style="max-width:160px;">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Fecha emisión origen</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-menu v-model="menuRefDate" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition" max-width="290">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field :value="formatDateDisplay(documents.adjustment_note.reference_date)" :error="$v.documents.adjustment_note.reference_date.$error" v-bind="attrs" v-on="on" append-icon="mdi-calendar-blank" placeholder="dd-mm-aaaa" outlined single-line dense readonly hide-details />
                            </template>
                            <v-date-picker v-model="documents.adjustment_note.reference_date" @input="menuRefDate=false" no-title :first-day-of-week="1" type="date" locale="es" max-width="290" color="blue-500">
                              <v-row class="mb-2 px-6" align="center" justify="end">
                                <v-btn class="body-1" :ripple="false" text color="blue-500" @click="documents.adjustment_note.reference_date=''; menuRefDate=false">Limpiar</v-btn>
                                <v-spacer />
                                <v-btn @click="documents.adjustment_note.reference_date=new Date().toISOString().slice(0,10); menuRefDate=false" color="blue-500">Hoy</v-btn>
                              </v-row>
                            </v-date-picker>
                          </v-menu>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="2" class="pa-0 mx-2">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">{{ isND ? 'Tipo de nota de débito' : 'Tipo de nota de crédito' }}</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-autocomplete
                            v-model="documents.adjustment_note.response_code"
                            :items="noteReasonTypes"
                            :error="$v.documents.adjustment_note.response_code.$error"
                            item-value="val"
                            item-text="description"
                            :placeholder="isND ? 'Selecciona el tipo de ND' : 'Selecciona el tipo de NC'"
                            :menu-props="{ overflowY: true, transition: 'slide-y-transition' }"
                            height="40"
                            single-line
                            outlined
                            dense
                            hide-details
                            append-icon="mdi-chevron-down"
                          >
                            <template v-slot:item="data">
                              <v-list-item-title class="font-weight-regular">{{data.item.description}} ({{data.item.val}})</v-list-item-title>
                            </template>
                            <template v-slot:selection="data">
                              <v-list-item-title class="grey-500--text py-1" style="min-width: 180px !important">{{data.item.description}} ({{data.item.val}})</v-list-item-title>
                            </template>
                          </v-autocomplete>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="3" class="pa-0 mx-2">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Motivo o sustento</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field v-model="documents.adjustment_note.description" :error="$v.documents.adjustment_note.description.$error" placeholder="Descripción del motivo" outlined single-line hide-details dense />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- 4. ITEMS -->
        <v-expansion-panels v-model="panelItems" :accordion="false" class="mt-5">
          <v-expansion-panel>
            <v-expansion-panel-header class="px-5 py-8">
              <v-row no-gutters align="center">
                <v-col class="pa-0">
                  <span class="subtitle-2 grey-700--text font-weight-bold d-flex align-center">
                    <v-icon class="mr-2" size="18" color="grey-700">mdi-cart-outline</v-icon>Productos y/o servicios
                  </span>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-7 pb-2">
              <div v-if="!documents.items.length" class="text-center pa-6 caption grey-500--text">
                Agrega un ítem para continuar
              </div>
              <div class="mb-n8 ma-0 pa-0" v-for="(item, idx) in documents.items" :key="idx">
                <v-divider class="mt-16 mb-8" v-if="idx > 0" />
                <v-row align="center" no-gutters>
                  <v-col cols="auto" class="pa-0 mr-2 mt-5" style="min-width:28px;">
                    <v-chip class="px-2" color="blue-100" small label>{{ idx + 1 }}</v-chip>
                  </v-col>
                  <v-col class="pa-0">
                    <v-row align="end">
                      <v-col cols="1" class="pa-0 mx-2">
                        <span class="grey-500--text body-2">Tipo</span>
                        <v-select v-model="item.type" :items="itemTypes" placeholder="Selecciona" dense hide-details outlined single-line @change="onItemFieldChange(idx, 'type', $event)" />
                      </v-col>
                      <v-col cols="1" class="pa-0 mx-2">
                        <span class="grey-500--text body-2">Código</span>
                        <v-text-field v-model="item.code" dense hide-details outlined single-line />
                      </v-col>
                      <v-col cols="2" class="pa-0 mx-2">
                        <span class="grey-500--text body-2">Nombre</span>
                        <v-text-field v-model="item.name" :error="$v.documents.items.$each[idx].name.$error" dense hide-details outlined single-line />
                      </v-col>
                      <v-col cols="1" class="pa-0 mx-2">
                        <span class="grey-500--text body-2">U.M.</span>
                        <v-select v-model="item.unit" :items="unitOptions" :error="$v.documents.items.$each[idx].unit.$error" placeholder="Unidad" dense hide-details outlined single-line />
                      </v-col>
                      <v-col cols="1" class="pa-0 mx-2">
                        <span class="grey-500--text body-2">Cantidad</span>
                        <v-text-field v-model="item.quantity" :error="$v.documents.items.$each[idx].quantity.$error" dense hide-details outlined single-line @input="recalc++" />
                      </v-col>
                      <v-col cols="1" class="pa-0 mx-2">
                        <span class="grey-500--text body-2">Precio unit.</span>
                        <v-text-field v-model="item.price" :error="$v.documents.items.$each[idx].price.$error" dense hide-details outlined single-line @input="recalc++" />
                      </v-col>
                      <v-col cols="2" class="pa-0 mx-2">
                        <span class="grey-500--text body-2">Afectación IGV</span>
                        <v-autocomplete
                          v-model="item.afect"
                          :items="afectOptions"
                          :error="$v.documents.items.$each[idx].afect.$error"
                          item-value="val"
                          item-text="description"
                          placeholder="Selecciona"
                          :menu-props="{ overflowY: true, transition: 'slide-y-transition' }"
                          height="40"
                          single-line
                          outlined
                          dense
                          hide-details
                          append-icon="mdi-chevron-down"
                          @change="onItemFieldChange(idx, 'afect', $event)"
                        >
                          <template v-slot:item="data">
                            <v-list-item-title class="font-weight-regular">{{data.item.description}} ({{data.item.val}})</v-list-item-title>
                          </template>
                          <template v-slot:selection="data">
                            <v-list-item-title class="grey-500--text py-1" style="min-width: 180px !important">{{data.item.description}} ({{data.item.val}})</v-list-item-title>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-spacer />
                      <v-col cols="auto" class="pa-0 mx-2 ml-auto" style="min-width:120px;">
                        <span class="grey-500--text body-2 d-block text-right font-weight-medium">Subtotal</span>
                        <div class="d-flex align-center justify-end" style="min-height:40px;">
                          <span class="subtitle-2 grey-700--text font-weight-bold">{{ fmt2(calcItemSub(item)) }} {{ documents.currency }}</span>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row v-if="item.afect === '37'" align="center" class="mt-3">
                      <v-col cols="3" class="pa-0 mx-2">
                        <span class="grey-500--text body-2">Motivo O.G.</span>
                        <v-select v-model="item.motOG" :items="motOGCatalog(item)" :error="$v.documents.items.$each[idx].motOG.$error" placeholder="Selecciona el motivo" dense hide-details outlined single-line />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="auto" class="pa-0 ml-4 mr-n4 mt-5 align-self-start" style="min-width:35px;">
                    <v-btn v-if="idx > 0" @click="removeItem(idx)" :disabled="documents.items.length === 1" min-width="20" max-width="20" min-height="28" max-height="28" text color="grey-200" :ripple="false"><v-icon size="24">mdi-delete</v-icon></v-btn>
                  </v-col>
                </v-row>
              </div>
              <v-col class="px-0 mt-10 pb-0 text-left">
                <v-btn @click="addItem" text color="blue-500" :ripple="false">
                  <v-icon left>mdi-basket-plus</v-icon>
                  <span class="font-weight-medium body-1">Agregar producto</span>
                </v-btn>
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- 5. DETRACCIÓN (Factura + 1001) -->
        <v-expansion-panels v-if="tieneDetraccion" v-model="panelDetrac" :accordion="false" class="mt-5">
          <v-expansion-panel>
            <v-expansion-panel-header class="px-5 py-8">
              <v-row no-gutters align="center">
                <v-col class="pa-0">
                  <span class="subtitle-2 grey-700--text font-weight-bold d-flex align-center">
                    <v-icon class="mr-2" size="18" color="grey-700">mdi-flash</v-icon>Detracción
                    <v-chip class="ml-3 spot-chip" x-small>Operación sujeta a detracción</v-chip>
                  </span>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-7 pb-8">
              <v-alert class="mb-4" text outlined color="var(--light-yellow-500)" rounded>
                <div class="d-flex pa-0 align-center">
                  <v-icon color="var(--light-yellow-500)">mdi-alert</v-icon>
                  <div class="ml-3 alert-description">
                    <span class="d-block body-2">El monto de detracción <span class="font-weight-bold">siempre en Soles (PEN)</span>, independiente de la moneda del comprobante.</span>
                  </div>
                </div>
              </v-alert>
              <v-list class="transparent pa-0">
                <v-row>
                  <v-col cols="5" class="pa-0 mx-2">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Bien/Servicio sujeto <span class="caption grey-300--text" style="line-height: inherit;">(Cat.54)</span></v-list-item-title>
                        <v-list-item-subtitle>
                          <v-autocomplete
                            v-model="detraction.service_code"
                            :items="detractionGoods"
                            item-value="cod"
                            :item-text="(o) => `${o.desc} (${o.cod})`"
                            placeholder="Selecciona el bien o servicio"
                            :menu-props="{ overflowY: true, transition: 'slide-y-transition' }"
                            height="40"
                            single-line
                            outlined
                            dense
                            hide-details
                            append-icon="mdi-chevron-down"
                          />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="3" class="pa-0 mx-2">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">N° Cuenta Banco Nación</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field v-model="detraction.bank_account" :error="$v.detraction.bank_account.$error" placeholder="00-XXX-XXXXXX" maxlength="13" oninput="this.value=this.value.replace(/[^0-9-]/g,'')" outlined single-line hide-details dense />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="3" class="pa-0 mx-2">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Medio de pago</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-autocomplete
                            v-model="detraction.payment_means_code"
                            :items="paymentMeans"
                            item-value="cod"
                            :item-text="(o) => `${o.desc} (${o.cod})`"
                            placeholder="Selecciona el medio de pago"
                            :menu-props="{ overflowY: true, transition: 'slide-y-transition' }"
                            height="40"
                            single-line
                            outlined
                            dense
                            hide-details
                            append-icon="mdi-chevron-down"
                          />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
                <v-row class="mt-n2">
                  <v-col cols="3" class="pa-0 mx-2">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">% Detracción</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field v-model="detraction.rate" :error="$v.detraction.rate.$error" type="number" min="0" max="100" step="0.01" outlined single-line hide-details dense @input="recalc++" />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="3" class="pa-0 mx-2">
                    <v-list-item class="pa-0">
                      <v-list-item-content>
                        <v-list-item-title class="grey-500--text py-1">Monto detracción (S/)</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field :value="`S/ ${fmt2(detractionAmount)}`" readonly outlined single-line hide-details dense />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- 6. CRÉDITO / CUOTAS (Factura + Crédito) -->
        <v-expansion-panels v-if="esCredito" v-model="panelCredit" :accordion="false" class="mt-5">
          <v-expansion-panel>
            <v-expansion-panel-header class="px-5 py-8">
              <v-row no-gutters align="center">
                <v-col class="pa-0">
                  <span class="subtitle-2 grey-700--text font-weight-bold d-flex align-center"><v-icon class="mr-2" size="18" color="grey-700">mdi-calendar-clock</v-icon>Información de crédito / cuotas</span>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-7 pb-2">
              <v-row align="center">
                <v-col cols="4" class="pa-0 mx-2">
                  <span class="grey-500--text body-1">Monto neto pendiente de pago</span>
                  <v-text-field v-model="documents.net_pending_amount" type="number" step="0.01" placeholder="0.00" outlined single-line hide-details dense />
                  <span class="caption grey-500--text d-block">No incluye anticipos, retenciones ni detracciones.</span>
                </v-col>
              </v-row>
              <div class="ma-0 pa-0" :class="{ 'mt-10': idx === 0 }" v-for="(c, idx) in documents.installments" :key="idx">
                <v-divider class="mt-6 mb-4" v-if="idx > 0" />
                <v-row align="end" no-gutters>
                  <v-col cols="auto" class="pa-0 mr-2 align-self-end" style="min-width:28px; padding-bottom: 6px;">
                    <v-chip class="px-2" color="blue-100" small label>{{ idx + 1 }}</v-chip>
                  </v-col>
                  <v-col class="pa-0">
                    <v-row align="end">
                      <v-col cols="3" class="pa-0 mx-2" style="max-width:200px;">
                        <span class="grey-500--text body-2">Fecha vencimiento</span>
                        <v-menu v-model="menuInstallment[idx]" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition" max-width="290">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="formatDateDisplay(c.due_date)" v-bind="attrs" v-on="on" append-icon="mdi-calendar-blank" placeholder="dd-mm-aaaa" outlined single-line dense readonly hide-details />
                          </template>
                          <v-date-picker v-model="c.due_date" @input="$set(menuInstallment, idx, false)" no-title :first-day-of-week="1" type="date" locale="es" max-width="290" color="blue-500">
                            <v-row class="mb-2 px-6" align="center" justify="end">
                              <v-btn class="body-1" :ripple="false" text color="blue-500" @click="c.due_date=''; $set(menuInstallment, idx, false)">Limpiar</v-btn>
                              <v-spacer />
                              <v-btn @click="c.due_date=new Date().toISOString().slice(0,10); $set(menuInstallment, idx, false)" color="blue-500">Hoy</v-btn>
                            </v-row>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="2" class="pa-0 mx-2" style="max-width:160px;">
                        <span class="grey-500--text body-2">Monto</span>
                        <v-text-field v-model="c.amount" dense hide-details outlined single-line />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="auto" class="pa-0 ml-n2" style="min-width:35px; padding-top: 24px;">
                    <v-btn @click="removeInstallment(idx)" min-width="20" max-width="20" min-height="28" max-height="28" text color="grey-200" :ripple="false"><v-icon size="24">mdi-delete</v-icon></v-btn>
                  </v-col>
                </v-row>
              </div>
              <v-col class="px-0 mt-5 d-flex align-center">
                <v-btn @click="addInstallment" :disabled="documents.installments.length >= 60" text color="blue-500" :ripple="false">
                  <v-icon left>mdi-calendar-plus</v-icon>
                  <span class="font-weight-medium body-1">Agregar cuota</span>
                </v-btn>
                <span class="ml-3 caption grey-500--text">Máximo 60 cuotas. Al menos 1 requerida.</span>
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- 7. TOTALES -->
        <v-expansion-panels v-model="panelTotals" :accordion="false" class="mt-5">
          <v-expansion-panel>
            <v-expansion-panel-header class="px-5 py-8">
              <v-row no-gutters align="center">
                <v-col class="pa-0">
                  <span class="subtitle-2 grey-700--text font-weight-bold d-flex align-center"><v-icon class="mr-2" size="18" color="grey-700">mdi-calculator</v-icon>Totales</span>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-7 pb-8">
              <v-row no-gutters justify="end">
                <v-col cols="12" sm="8" md="6" lg="5">
                  <v-list class="transparent pa-0" dense>
                    <v-list-item v-if="subTotals.gravadas > 0" class="px-0 py-0" style="min-height: 32px;">
                      <v-list-item-title class="grey-500--text body-2">Valor venta gravado</v-list-item-title>
                      <v-list-item-subtitle class="text-right body-2 grey-700--text">{{ fmt2(subTotals.gravadas) }} {{ documents.currency }}</v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item v-if="subTotals.inafectas > 0" class="px-0 py-0" style="min-height: 32px;">
                      <v-list-item-title class="grey-500--text body-2">Valor venta inafecto</v-list-item-title>
                      <v-list-item-subtitle class="text-right body-2 grey-700--text">{{ fmt2(subTotals.inafectas) }} {{ documents.currency }}</v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item v-if="subTotals.exportadas > 0" class="px-0 py-0" style="min-height: 32px;">
                      <v-list-item-title class="grey-500--text body-2">Valor venta exportación</v-list-item-title>
                      <v-list-item-subtitle class="text-right body-2 grey-700--text">{{ fmt2(subTotals.exportadas) }} {{ documents.currency }}</v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item v-if="subTotals.exoneradas > 0" class="px-0 py-0" style="min-height: 32px;">
                      <v-list-item-title class="grey-500--text body-2">Valor venta exonerado</v-list-item-title>
                      <v-list-item-subtitle class="text-right body-2 grey-700--text">{{ fmt2(subTotals.exoneradas) }} {{ documents.currency }}</v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item v-if="subTotals.gratuitas > 0" class="px-0 py-0" style="min-height: 32px;">
                      <v-list-item-title class="grey-500--text body-2">Valor referencial gratuitas</v-list-item-title>
                      <v-list-item-subtitle class="text-right body-2 grey-700--text">{{ fmt2(subTotals.gratuitas) }} {{ documents.currency }}</v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="px-0 py-0" style="min-height: 32px;">
                      <v-list-item-title class="grey-500--text body-2">Valor de venta</v-list-item-title>
                      <v-list-item-subtitle class="text-right body-2 grey-700--text">{{ fmt2(subTotals.valorVenta) }} {{ documents.currency }}</v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item v-if="subTotals.igvTotal > 0" class="px-0 py-0" style="min-height: 32px;">
                      <v-list-item-title class="grey-500--text body-2">IGV (18%)</v-list-item-title>
                      <v-list-item-subtitle class="text-right body-2 grey-700--text">{{ fmt2(subTotals.igvTotal) }} {{ documents.currency }}</v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item v-if="tieneDetraccion && Number(detractionAmount) > 0" class="px-0 py-0" style="min-height: 32px;">
                      <v-list-item-title class="grey-500--text body-2">Monto detracción (S/)</v-list-item-title>
                      <v-list-item-subtitle class="text-right body-2 grey-700--text">− {{ fmt2(detractionAmount) }} PEN</v-list-item-subtitle>
                    </v-list-item>
                    <v-divider class="my-2" />
                    <v-list-item class="px-0 py-0" style="min-height: 36px;">
                      <v-list-item-title class="subtitle-2 grey-700--text font-weight-bold">Importe total</v-list-item-title>
                      <v-list-item-subtitle class="text-right subtitle-2 grey-700--text font-weight-bold">{{ fmt2(subTotals.total) }} {{ documents.currency }}</v-list-item-subtitle>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- ACTIONS -->
        <v-row class="mt-5" no-gutters justify="end">
          <v-btn outlined class="mr-2" :to="{ name: 'DocumentsList', params: $route.params }">Cancelar</v-btn>
          <v-btn class="mr-2" outlined :loading="loadingPreviewPDF" :disabled="!documents.document_type" @click="handlePreviewPDFModal">Previsualizar PDF</v-btn>
          <v-btn color="blue-500" :loading="loadingSave" @click="handleSubmit" :disabled="!documents.document_type">Crear documento</v-btn>
        </v-row>

      </v-col>
    </v-col>

    <!-- dialog preview PDF -->
    <v-dialog v-model="dialogReviewPDF" width="700" persistent no-click-animation scrollable overlay-color="overlay">
      <v-card>
        <v-toolbar class="transparent" flat height="46">
          <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-semibold">Previsualización del documento</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-4">
              <v-btn @click="dialogReviewPDF=false" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <render-pdf
          :basicRender="true"
          :loaderRender="loaderRender"
          :renderUrl="renderUrlPDF"
          :flat="true"
          :showToolbar="false"
          :showTemplateSelector="false"
          :showFooter="false"
        />
        <v-divider />
        <v-card-actions class="py-2 px-5">
          <v-btn @click="dialogReviewPDF=false" outlined>Cancelar</v-btn>
          <v-spacer />
          <v-btn @click="dialogReviewPDF=false; handleSubmit()" color="blue-500" :loading="loadingSave">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog preview PDF -->
  </v-row>
</template>

<script>
import { required, decimal, maxLength, minLength, between, requiredIf } from 'vuelidate/lib/validators'
import MiniHeader from '@/components/commons/MiniHeader'
import PermissionDenied from '@/modules/http/views/PermissionDenied'
import DocumentTypes from '@/collections/documentTypesPE'
import { currencies } from '@/collections/currenciesPE'
import RenderPdf from '@/components/files/RenderPdf'
import http from '@/backend/http'
import { debounce } from 'lodash'

const AFECT_IGV = [
  { val: '10', description: 'Gravado oneroso', cat05: '1000', name: 'IGV', type_code: 'VAT', category_id: 'S' },
  { val: '20', description: 'Exonerado oneroso', cat05: '9997', name: 'EXO', type_code: 'VAT', category_id: 'E' },
  { val: '30', description: 'Inafecto oneroso', cat05: '9998', name: 'INA', type_code: 'FRE', category_id: 'O' },
  { val: '37', description: 'Gratuito donación', cat05: '9996', name: 'GRA', type_code: 'FRE', category_id: 'Z' },
  { val: '40', description: 'Exportación/No dom.', cat05: '9995', name: 'EXP', type_code: 'FRE', category_id: 'G' }
]
const MOT_OG_BIEN = ['Donación', 'Retiro', 'Publicidad', 'Bonificación', 'Premio', 'Entrega a trabajadores']
const MOT_OG_SERV = ['Bonificación', 'Retiro', 'Muestras médicas', 'Convenio colectivo', 'Premio', 'Publicidad', 'Transferencia gratuita']
const DETRAC_BS = [
  { cod: '001', desc: 'Azúcar y melaza de caña' }, { cod: '002', desc: 'Arroz' }, { cod: '003', desc: 'Alcohol etílico' },
  { cod: '004', desc: 'Recursos hidrobiológicos' }, { cod: '005', desc: 'Maíz amarillo duro' }, { cod: '006', desc: 'Algodón' },
  { cod: '008', desc: 'Madera' }, { cod: '009', desc: 'Arena y piedra' }, { cod: '012', desc: 'Intermediación laboral' },
  { cod: '019', desc: 'Arrendamiento bienes muebles e inmuebles' }, { cod: '020', desc: 'Mantenimiento bienes muebles' },
  { cod: '021', desc: 'Movimiento de carga' }, { cod: '022', desc: 'Otros servicios empresariales' },
  { cod: '023', desc: 'Leche cruda entera' }, { cod: '024', desc: 'Comisión mercantil' }, { cod: '025', desc: 'Fabricación por encargo' }
]
const MEDIOS_PAGO = [
  { cod: '001', desc: 'Depósito en cuenta' }, { cod: '002', desc: 'Giro' }, { cod: '003', desc: 'Transferencia de fondos' },
  { cod: '004', desc: 'Orden de pago' }, { cod: '005', desc: 'Tarjeta de débito' }, { cod: '006', desc: 'Tarjeta de crédito (nacional)' },
  { cod: '008', desc: 'Efectivo sin obligación' }, { cod: '009', desc: 'Efectivo otros casos' }
]
const TIPOS_DOC_REC = [
  { val: '6', description: 'RUC' },
  { val: '1', description: 'DNI' },
  { val: '4', description: 'Carné de extranjería' },
  { val: '7', description: 'Pasaporte' },
  { val: '0', description: 'Otros / Sin documento' }
]
const UNIDADES = ['NIU', 'ZZ', 'KGM', 'LTR', 'MTR', 'MTK', 'MTQ', 'HUR', 'DAY', 'MON', 'SET', 'PAR']
const TIPOS_NC = [
  { val: '01', description: 'Anulación de la operación' },
  { val: '02', description: 'Anulación por error en el RUC' },
  { val: '03', description: 'Descuento global' },
  { val: '04', description: 'Devolución total' },
  { val: '05', description: 'Corrección por error en la descripción' },
  { val: '06', description: 'Devolución por ítem' },
  { val: '07', description: 'Descuento por ítem' },
  { val: '08', description: 'Bonificación' },
  { val: '09', description: 'Disminución en el valor' },
  { val: '10', description: 'Ajuste de operaciones de exportación' },
  { val: '11', description: 'Otros conceptos' },
  { val: '12', description: 'Ajustes — montos y/o fechas de pago' }
]
// SUNAT Catálogo 10 — debit note reason types
const TIPOS_ND = [
  { val: '01', description: 'Intereses por mora' },
  { val: '02', description: 'Aumento en el valor' },
  { val: '03', description: 'Penalidades / otros conceptos' },
  { val: '10', description: 'Ajustes de operaciones de exportación' },
  { val: '11', description: 'Ajustes afectos al IVAP' }
]
const OPERATION_TYPES = [
  { value: '0101', description: 'Venta interna' },
  { value: '0201', description: 'Export. servicio' },
  { value: '0401', description: 'Export. bienes' },
  { value: '1001', description: 'Sujeto a detracción' }
]

const plusMonths = (n) => {
  const d = new Date()
  d.setMonth(d.getMonth() + n)
  return d.toISOString().slice(0, 10)
}
const str2 = (n) => parseFloat(n || 0).toFixed(2)
// N° Cuenta Banco Nación: 11 dígitos (los guiones del formato 00-XXX-XXXXXX no cuentan)
const bankAccount11 = (value) => !value || String(value).replace(/\D/g, '').length === 11
const fmt2 = (n) => parseFloat(n || 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

const initialItem = () => ({
  type: '',
  code: '',
  name: '',
  unit: '',
  quantity: '',
  price: '',
  afect: '',
  cat05: '',
  motOG: '',
  valRef: ''
})

const initialDocuments = () => ({
  document_type: '',
  operation_type: '',
  currency: 'PEN',
  date: '',
  time: '',
  due_date: '',
  number: '',
  payment_method: 'Contado',
  glosa: '',
  internal_id: '',
  agency_branch_id: '0000',
  net_pending_amount: '',
  customer: {
    tax_id_type: '',
    tax_id: '',
    name: '',
    address: '',
    municipality: '',
    city: '',
    department: ''
  },
  items: [initialItem()],
  installments: [],
  adjustment_note: {
    reference_type: '',
    reference_serial: '',
    reference_number: '',
    reference_date: '',
    response_code: '',
    description: ''
  }
})

export default {
  name: 'documents-create-pe',
  components: {
    MiniHeader,
    PermissionDenied,
    RenderPdf
  },
  data: () => ({
    panelInf: 0,
    panelRec: 0,
    panelRef: 0,
    panelItems: 0,
    panelDetrac: 0,
    panelCredit: 0,
    panelTotals: 0,
    scroll: 0,
    loadingSave: false,
    recalc: 0,
    menuIssueTime: false,
    menuIssueDate: false,
    menuDueDate: false,
    menuRefDate: false,
    menuInstallment: {},
    dialogReviewPDF: false,
    renderUrlPDF: null,
    loaderRender: false,
    loadingPreviewPDF: false,
    customerList: [],
    customerLoading: false,
    customerMenu: false,
    isSelectingCustomer: false,
    detraction: {
      service_code: '',
      bank_account: '',
      payment_means_code: '',
      rate: ''
    },
    documents: initialDocuments(),
    afectOptions: AFECT_IGV,
    detractionGoods: DETRAC_BS,
    paymentMeans: MEDIOS_PAGO,
    receptorDocTypes: TIPOS_DOC_REC,
    unitOptions: UNIDADES,
    operationTypes: OPERATION_TYPES,
    itemTypes: ['Bien', 'Servicio'],
    ncRefTypes: [
      { value: '01', description: 'Factura' },
      { value: '03', description: 'Boleta' }
    ],
    breadcrumbs: {
      main: 'Emisión',
      children: [
        { text: 'Documentos', route: 'DocumentsList' },
        { text1: 'Crear documento' }
      ]
    }
  }),
  computed: {
    documentTypeOptions () {
      return DocumentTypes.filter((d) => ['PE01', 'PE03', 'PE07', 'PE08'].includes(d.id))
        .map((d) => ({ id: d.id, name: d.name }))
    },
    currencyOptions () {
      const docType = DocumentTypes.find((d) => d.id === this.documents.document_type)
      const allowed = docType?.currencies?.length ? docType.currencies : ['PEN', 'USD']
      const list = currencies.filter((c) => allowed.includes(c.code)).map((c) => c.code)
      return list.length ? list : allowed
    },
    isFactura () { return this.documents.document_type === 'PE01' },
    isBoleta () { return this.documents.document_type === 'PE03' },
    isNC () { return this.documents.document_type === 'PE07' },
    isND () { return this.documents.document_type === 'PE08' },
    isNota () { return this.isNC || this.isND },
    noteReasonTypes () { return this.isND ? TIPOS_ND : TIPOS_NC },
    tieneDetraccion () { return this.isFactura && this.documents.operation_type === '1001' },
    esCredito () { return this.isFactura && this.documents.payment_method === 'Credito' },
    subTotals () {
      // recalc dep — forces reactivity when item fields change
      // eslint-disable-next-line no-unused-vars
      const _ = this.recalc
      let gravadas = 0
      let exoneradas = 0
      let inafectas = 0
      let exportadas = 0
      let gratuitas = 0
      let igvTotal = 0
      this.documents.items.forEach((item) => {
        const vv = this.calcItemNet(item)
        const igv = this.calcItemIGV(item)
        if (item.afect === '10') {
          gravadas += vv
          igvTotal += igv
        } else if (item.afect === '20') {
          exoneradas += vv
        } else if (item.afect === '30') {
          inafectas += vv
        } else if (item.afect === '40') {
          exportadas += vv
        } else if (item.afect === '37') {
          gratuitas += parseFloat(item.quantity || 0) * parseFloat(item.valRef || item.price || 0)
        }
      })
      const valorVenta = gravadas + inafectas + exoneradas + exportadas
      const total = parseFloat((valorVenta + igvTotal).toFixed(2))
      return { gravadas, exoneradas, inafectas, exportadas, gratuitas, igvTotal, valorVenta, total }
    },
    detractionAmount () {
      if (!this.tieneDetraccion) return '0.00'
      const pct = parseFloat(this.detraction.rate || 0)
      return (this.subTotals.total * pct / 100).toFixed(2)
    },
    seriePlaceholder () {
      if (this.documents.document_type === 'PE01') return 'F001-00000001'
      if (this.documents.document_type === 'PE03') return 'B001-00000001'
      if (this.documents.document_type === 'PE07') return 'FC01-00000001'
      if (this.documents.document_type === 'PE08') return 'FD01-00000001'
      return 'AXXX-NNNNNNNN'
    }
  },
  watch: {
    'documents.document_type' (val) {
      if (!val) return
      this.documents.items = [initialItem()]
      this.documents.number = ''
      if (val === 'PE01') {
        this.documents.operation_type = '0101'
        this.documents.customer.tax_id_type = '6'
      }
      if (val === 'PE03') {
        this.documents.operation_type = '0101'
        this.documents.payment_method = 'Contado'
        this.documents.installments = []
        this.documents.customer.tax_id_type = '1'
      }
      if (val === 'PE07' || val === 'PE08') {
        this.documents.operation_type = '0101'
        this.documents.payment_method = 'Contado'
        this.documents.installments = []
        // reason catalogs differ between NC and ND, so a stale code would be invalid
        this.documents.adjustment_note.response_code = ''
      }
    },
    'documents.operation_type' (val) {
      if (val !== '1001') {
        // keep struct but reset rate so detractionAmount is 0 — section auto-hides via tieneDetraccion
      }
    },
    'documents.payment_method' (val) {
      if (val !== 'Credito') {
        this.documents.installments = []
        this.documents.net_pending_amount = ''
      } else if (!this.documents.installments.length) {
        this.documents.net_pending_amount = this.subTotals.total.toFixed(2)
      }
    },
    'documents.date' (val) {
      if (val && !this.esCredito) {
        const d = new Date(val)
        d.setDate(d.getDate() + 30)
        this.documents.due_date = d.toISOString().slice(0, 10)
      }
    },
    'documents.customer.tax_id' (val, oldVal) {
      // Clear autofilled receptor data when the document number changes (unless we're selecting a customer)
      if (val !== oldVal && oldVal !== undefined && !this.isSelectingCustomer) {
        this.clearCustomerFields()
      }
    }
  },
  methods: {
    onScroll (e) {
      this.scroll = e.target?.scrollingElement?.scrollTop ?? 0
    },
    debounceMethod: debounce(function (callback) {
      return callback()
    }, 700),
    handleTaxIdInput (value) {
      if (this.isSelectingCustomer) return
      if (value && value.length >= 3) {
        this.debounceMethod(() => this.searchCustomer(value))
      } else {
        this.customerList = []
        this.customerMenu = false
      }
    },
    searchCustomer (value) {
      this.customerLoading = true
      this.$store.dispatch('customers/LIST', {
        resource: 'customers',
        query: { q: value }
      })
        .then((response) => {
          this.customerList = response.data
          this.$nextTick(() => {
            this.customerMenu = this.customerList.length > 0
          })
        })
        .catch(() => {
          this.customerList = []
          this.customerMenu = false
        })
        .finally(() => {
          this.customerLoading = false
        })
    },
    selectCustomer (customer) {
      this.isSelectingCustomer = true
      this.documents.customer = {
        ...this.documents.customer,
        tax_id: customer.tax_id || '',
        name: customer.name || '',
        address: customer.address || '',
        municipality: customer.municipality || '',
        city: customer.city || '',
        department: customer.department || customer.state || ''
      }
      this.customerMenu = false
      this.customerList = []
      this.$v.documents.customer.tax_id.$touch()
      this.$v.documents.customer.name.$touch()
      this.$nextTick(() => {
        this.isSelectingCustomer = false
      })
    },
    handleCustomerFocus () {
      const taxId = this.documents.customer.tax_id
      if (taxId && taxId.length >= 3 && this.customerList.length > 0) {
        this.customerMenu = true
      }
    },
    handleCustomerBlur () {
      setTimeout(() => {
        this.customerMenu = false
      }, 200)
    },
    clearCustomerFields () {
      this.documents.customer.name = ''
      this.documents.customer.address = ''
      this.documents.customer.municipality = ''
      this.documents.customer.city = ''
      this.documents.customer.department = ''
    },
    motOGCatalog (item) {
      return item.type === 'Servicio' ? MOT_OG_SERV : MOT_OG_BIEN
    },
    calcItemSub (item) {
      if (item.afect === '37') return '0.00'
      return (parseFloat(item.quantity || 0) * parseFloat(item.price || 0)).toFixed(2)
    },
    calcItemNet (item) {
      if (item.afect === '37') return 0
      const bruto = parseFloat(item.quantity || 0) * parseFloat(item.price || 0)
      return item.afect === '10' ? parseFloat((bruto / 1.18).toFixed(2)) : bruto
    },
    calcItemIGV (item) {
      if (item.afect !== '10') return 0
      return parseFloat((this.calcItemNet(item) * 0.18).toFixed(2))
    },
    onItemFieldChange (idx, field, val) {
      if (field === 'afect') {
        const a = AFECT_IGV.find((x) => x.val === val)
        if (a) this.documents.items[idx].cat05 = a.cat05
        if (val !== '37') this.documents.items[idx].motOG = ''
      }
      if (field === 'type') {
        // reset motOG since catalog differs
        this.documents.items[idx].motOG = ''
      }
      this.recalc++
    },
    addItem () {
      this.documents.items.push(initialItem())
      this.recalc++
    },
    removeItem (idx) {
      if (this.documents.items.length === 1) return
      this.documents.items.splice(idx, 1)
      this.recalc++
    },
    addInstallment () {
      if (!Array.isArray(this.documents.installments)) {
        this.$set(this.documents, 'installments', [])
      }
      if (this.documents.installments.length >= 60) return
      const n = this.documents.installments.length + 1
      const newInstallments = [...this.documents.installments, { due_date: plusMonths(n), amount: '0.00' }]
      this.$set(this.documents, 'installments', newInstallments)
    },
    removeInstallment (idx) {
      this.documents.installments.splice(idx, 1)
    },
    fmt2,
    formatDateDisplay (value) {
      if (!value) return ''
      const parts = String(value).slice(0, 10).split('-')
      if (parts.length !== 3) return value
      return `${parts[2]}-${parts[1]}-${parts[0]}`
    },
    importeEnLetras (n, moneda) {
      const m = moneda === 'PEN' ? 'SOLES' : moneda === 'USD' ? 'DOLARES' : moneda
      return `SON ${Math.floor(n).toLocaleString('es-PE')} Y ${String(Math.round((n % 1) * 100)).padStart(2, '0')}/100 ${m}`
    },
    supplier () {
      // TODO P-supplier: confirmar con backend si supplier viaja en payload o se infiere del account.
      // Por ahora lo armamos desde el account logueado.
      const account = this.$store.state.auth.account || {}
      return {
        tax_id: account.tax_id || '20610051406',
        tax_id_type: '6',
        name: account.name || 'AXTEROID S.A.C.',
        trade_name: account.trade_name || account.name || 'AXTEROID S.A.C.',
        address: account.address || '',
        municipality: account.municipality || '',
        city: account.city || 'Lima',
        department: account.department || 'Lima',
        ubigeo: account.ubigeo || '150122'
      }
    },
    buildPayload () {
      const d = this.documents
      const total = this.subTotals.total
      const gravadas = this.subTotals.gravadas
      const inafectas = this.subTotals.inafectas
      const exportadas = this.subTotals.exportadas
      const exoneradas = this.subTotals.exoneradas
      const gratuitas = this.subTotals.gratuitas
      const igvTotal = this.subTotals.igvTotal
      const valorVenta = this.subTotals.valorVenta
      const tieneDetrac = this.tieneDetraccion
      const dPct = parseFloat(this.detraction.rate || 0)
      const dMonto = parseFloat((total * dPct / 100).toFixed(2))

      let payments = []
      if (this.esCredito && d.installments.length > 0) {
        payments.push({ id: 'FormaPago', mean: 'Credito', amount: str2(total) })
        d.installments.forEach((c, i) => {
          payments.push({
            id: 'FormaPago',
            mean: `Cuota${String(i + 1).padStart(3, '0')}`,
            amount: str2(c.amount),
            due_date: c.due_date
          })
        })
      } else {
        payments = [{ id: 'FormaPago', mean: 'Contado' }]
      }

      const customer = {
        tax_id_type: d.customer.tax_id_type,
        tax_id: d.customer.tax_id,
        name: d.customer.name,
        address: d.customer.address || '-',
        municipality: d.customer.municipality || '-',
        city: d.customer.city || '-',
        department: d.customer.department || '-'
      }

      return {
        document_type: this.documents.document_type,
        numbering: false,
        test: this.$route.path.startsWith('/test'),
        document: {
          operation_type: d.operation_type,
          number: d.number,
          issued_date_time: `${d.date}T${d.time || '00:00:00'}`,
          ...(this.isFactura && d.due_date ? { due_date: d.due_date } : {}),
          currency: d.currency,
          supplier: this.supplier(),
          customer,
          items: d.items.map((item, i) => {
            const vv = this.calcItemNet(item)
            const igv = this.calcItemIGV(item)
            const a = AFECT_IGV.find((x) => x.val === item.afect) || AFECT_IGV[0]
            const esGrat = item.afect === '37'
            const valRef = esGrat ? parseFloat(item.valRef || item.price || 0) : 0
            const cant = parseFloat(item.quantity || 0)
            const priceNet = esGrat ? '0.00' : (cant > 0 ? str2(vv / cant) : '0.00')
            return {
              line: i + 1,
              ...(item.code ? { code: item.code } : {}),
              name: item.name + (esGrat && item.motOG ? ` ***** ${item.motOG} *****` : ''),
              unit: item.unit,
              quantity: str2(cant),
              price_net: priceNet,
              price: esGrat ? str2(valRef) : str2(parseFloat(item.price || 0)),
              price_type_code: esGrat ? '02' : '01',
              amount: esGrat ? str2(cant * valRef) : str2(vv),
              tax: str2(igv),
              taxes: [{
                code: a.cat05,
                name: a.name,
                type_code: a.type_code,
                category_id: a.category_id,
                exempt_reason_code: item.afect,
                amount: str2(igv),
                base: esGrat ? str2(cant * valRef) : str2(vv),
                rate: item.afect === '10' ? '18.00' : '0.00'
              }]
            }
          }),
          amount: {
            net: str2(valorVenta),
            tax: str2(igvTotal),
            total: str2(total),
            taxable_total: str2(gravadas),
            ...(inafectas + exportadas > 0 ? { non_taxable_total: str2(inafectas + exportadas) } : {}),
            ...(exoneradas > 0 ? { exempt_total: str2(exoneradas) } : {}),
            ...(gratuitas > 0 ? { free_of_charge_total: str2(gratuitas) } : {}),
            payable_total: str2(total)
          },
          taxes: [
            ...(igvTotal > 0 ? [{ code: '1000', name: 'IGV', type_code: 'VAT', category_id: 'S', amount: str2(igvTotal), base: str2(gravadas), rate: '18.00' }] : []),
            ...(exoneradas > 0 ? [{ code: '9997', name: 'EXO', type_code: 'VAT', category_id: 'E', amount: '0.00', base: str2(exoneradas), rate: '0.00' }] : []),
            ...(inafectas > 0 ? [{ code: '9998', name: 'INA', type_code: 'FRE', category_id: 'O', amount: '0.00', base: str2(inafectas), rate: '0.00' }] : []),
            ...(exportadas > 0 ? [{ code: '9995', name: 'EXP', type_code: 'FRE', category_id: 'G', amount: '0.00', base: str2(exportadas), rate: '0.00' }] : []),
            ...(gratuitas > 0 ? [{ code: '9996', name: 'GRA', type_code: 'FRE', category_id: 'Z', amount: '0.00', base: str2(gratuitas), rate: '0.00' }] : [])
          ],
          payments,
          ...(tieneDetrac ? {
            detraction: {
              payment_means_code: this.detraction.payment_means_code,
              service_code: this.detraction.service_code,
              bank_account: String(this.detraction.bank_account || '').replace(/\D/g, ''),
              amount: str2(dMonto),
              rate: str2(dPct)
            }
          } : {}),
          legends: [
            { code: '1000', value: this.importeEnLetras(total, d.currency) },
            ...(gratuitas > 0 ? [{ code: '1002', value: 'TRANSFERENCIA GRATUITA DE UN BIEN Y/O SERVICIO PRESTADO GRATUITAMENTE' }] : []),
            ...(tieneDetrac ? [{ code: '2006', value: 'Operacion sujeta a detraccion' }] : [])
          ],
          extra: {
            agency_branch_id: d.agency_branch_id || '0000',
            ...(d.internal_id ? { internal_id: d.internal_id } : {})
          },
          ...(d.glosa ? { custom: { glosa: d.glosa } } : {})
        }
      }
    },
    buildPayloadNote () {
      const d = this.documents
      const an = d.adjustment_note
      const { gravadas, exoneradas, inafectas, exportadas, igvTotal, valorVenta, total } = this.subTotals
      const customer = {
        tax_id_type: d.customer.tax_id_type,
        tax_id: d.customer.tax_id,
        name: d.customer.name,
        address: d.customer.address || '-',
        municipality: d.customer.municipality || '-',
        city: d.customer.city || '-',
        department: d.customer.department || '-'
      }
      return {
        document_type: this.documents.document_type,
        numbering: false,
        test: this.$route.path.startsWith('/test'),
        document: {
          number: d.number,
          issued_date_time: `${d.date}T${d.time || '00:00:00'}`,
          currency: d.currency,
          supplier: this.supplier(),
          customer,
          adjustment_note: {
            reference_id: `${an.reference_serial}-${an.reference_number}`,
            response_code: an.response_code,
            description: an.description
          },
          references: [{
            number: `${an.reference_serial}-${an.reference_number}`,
            type: an.reference_type ? `PE${an.reference_type}` : '',
            issue_date: an.reference_date,
            reason_code: an.response_code,
            reason_description: an.description
          }],
          items: d.items.map((item, i) => {
            const vv = this.calcItemNet(item)
            const igv = this.calcItemIGV(item)
            const a = AFECT_IGV.find((x) => x.val === item.afect) || AFECT_IGV[0]
            const cant = parseFloat(item.quantity || 0)
            const priceNet = cant > 0 ? str2(vv / cant) : '0.00'
            return {
              line: i + 1,
              ...(item.code ? { code: item.code } : {}),
              name: item.name,
              unit: item.unit,
              quantity: str2(cant),
              price_net: priceNet,
              price: str2(parseFloat(item.price || 0)),
              price_type_code: '01',
              amount: str2(vv),
              tax: str2(igv),
              taxes: [{
                code: a.cat05,
                name: a.name,
                type_code: a.type_code,
                category_id: a.category_id,
                exempt_reason_code: item.afect,
                amount: str2(igv),
                base: str2(vv),
                rate: item.afect === '10' ? '18.00' : '0.00'
              }]
            }
          }),
          amount: {
            net: str2(valorVenta),
            tax: str2(igvTotal),
            total: str2(total),
            taxable_total: str2(gravadas),
            ...(inafectas + exportadas > 0 ? { non_taxable_total: str2(inafectas + exportadas) } : {}),
            ...(exoneradas > 0 ? { exempt_total: str2(exoneradas) } : {}),
            payable_total: str2(total)
          },
          taxes: [
            ...(igvTotal > 0 ? [{ code: '1000', name: 'IGV', type_code: 'VAT', category_id: 'S', amount: str2(igvTotal), base: str2(gravadas), rate: '18.00' }] : []),
            ...(exoneradas > 0 ? [{ code: '9997', name: 'EXO', type_code: 'VAT', category_id: 'E', amount: '0.00', base: str2(exoneradas), rate: '0.00' }] : []),
            ...(inafectas > 0 ? [{ code: '9998', name: 'INA', type_code: 'FRE', category_id: 'O', amount: '0.00', base: str2(inafectas), rate: '0.00' }] : []),
            ...(exportadas > 0 ? [{ code: '9995', name: 'EXP', type_code: 'FRE', category_id: 'G', amount: '0.00', base: str2(exportadas), rate: '0.00' }] : [])
          ],
          legends: [{ code: '1000', value: this.importeEnLetras(total, d.currency) }],
          extra: {
            agency_branch_id: d.agency_branch_id || '0000',
            ...(d.internal_id ? { internal_id: d.internal_id } : {})
          },
          ...(d.glosa ? { custom: { glosa: d.glosa } } : {})
        }
      }
    },
    notifyError (msg) {
      if (this.$dialog && this.$dialog.message && typeof this.$dialog.message.error === 'function') {
        this.$dialog.message.error(msg)
      }
    },
    notifyInfo (msg) {
      if (this.$dialog && this.$dialog.message && typeof this.$dialog.message.info === 'function') {
        this.$dialog.message.info(msg)
      }
    },
    openInvalidPanels () {
      // reveal collapsed panels that contain invalid fields so their errors are visible
      if (this.isNota && this.$v.documents.adjustment_note.$anyError) this.panelRef = 0
    },
    handlePreviewPDFModal () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.openInvalidPanels()
        this.notifyError('Complete todos los campos obligatorios antes de continuar')
        return
      }
      const payload = this.isNota ? this.buildPayloadNote() : this.buildPayload()
      const code = this.documents.document_type.slice(2)
      const country = (this.$store.state.auth.account.country || 'pe').toLowerCase()
      this.renderUrlPDF = null
      this.loaderRender = true
      this.loadingPreviewPDF = true
      this.dialogReviewPDF = true
      const resource = `generation/${country}/${code}?preview=pdf`
      http.post(`/${resource}`, payload, { responseType: 'blob', headers: { Accept: 'application/pdf' } })
        .then((response) => {
          this.renderUrlPDF = URL.createObjectURL(response.data)
        })
        .catch((error) => {
          this.renderUrlPDF = null
          const msg = (error && error.response && error.response.data && error.response.data.message) || 'Error al generar la previsualización del PDF'
          this.notifyError(msg)
        })
        .finally(() => {
          this.loaderRender = false
          this.loadingPreviewPDF = false
        })
    },
    handleSubmit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.openInvalidPanels()
        this.notifyError('Complete todos los campos obligatorios antes de continuar')
        return
      }
      this.loadingSave = true
      const payload = this.isNota ? this.buildPayloadNote() : this.buildPayload()
      const code = this.documents.document_type.slice(2)
      const country = (this.$store.state.auth.account.country || 'pe').toLowerCase()
      this.$store.dispatch('documents/CREATE', {
        resource: `generation/${country}/${code}`,
        payload,
        isNotTest: true
      })
        .then((response) => {
          this.notifyInfo('Documento creado correctamente')
          const id = response && response.data && response.data.id
          if (id) {
            this.$router.push({ name: 'DocumentsRetrieve', params: { ...this.$route.params, id } })
          } else {
            this.$router.push({ name: 'DocumentsList', params: this.$route.params })
          }
        })
        .catch((error) => {
          const msg = (error && error.response && error.response.data && error.response.data.message) || 'Ha ocurrido un error al crear el documento'
          this.notifyError(msg)
        })
        .finally(() => {
          this.loadingSave = false
        })
    }
  },
  validations () {
    const isBoletaOver700 = this.isBoleta && this.subTotals.total > 700
    const installmentRules = this.esCredito
      ? { minLength: minLength(1), maxLength: maxLength(60) }
      : { maxLength: maxLength(60) }
    const detractionRules = this.tieneDetraccion
      ? {
          bank_account: { required, bankAccount11 },
          rate: { required, between: between(0, 100) }
        }
      : {
          bank_account: {},
          rate: {}
        }
    return {
      documents: {
        document_type: { required },
        date: { required },
        due_date: { required: requiredIf(() => this.esCredito) },
        number: { required, maxLength: maxLength(13) },
        customer: {
          tax_id: {
            required: requiredIf(() => this.isFactura || this.isNota || isBoletaOver700)
          },
          name: {
            required: requiredIf(() => this.isFactura || this.isNota || isBoletaOver700),
            maxLength: maxLength(250)
          }
        },
        items: {
          minLength: minLength(1),
          $each: {
            name: { required, maxLength: maxLength(250) },
            unit: { required },
            quantity: { required, decimal },
            price: { required, decimal },
            afect: { required },
            motOG: { required: requiredIf((item) => item.afect === '37') }
          }
        },
        installments: installmentRules,
        adjustment_note: {
          reference_type: { required: requiredIf(() => this.isNota) },
          reference_serial: { required: requiredIf(() => this.isNota) },
          reference_number: { required: requiredIf(() => this.isNota) },
          reference_date: { required: requiredIf(() => this.isNota) },
          response_code: { required: requiredIf(() => this.isNota) },
          description: { required: requiredIf(() => this.isNota) }
        }
      },
      detraction: detractionRules
    }
  }
}
</script>

<style scoped>
.no-radio-hover >>> .v-input--selection-controls__ripple {
  display: none !important;
}
.no-radio-hover >>> .v-radio:hover .v-input--selection-controls__input {
  background: transparent !important;
}
.no-radio-hover >>> .v-radio .v-input--selection-controls__input:hover::before {
  opacity: 0 !important;
}
.v-alert--text.v-alert--outlined {
  border-radius: 10px !important;
}
/* Vuetify paints the text-alert background on an internal ::before; under scoped styles
   it must be reached with a deep selector or the yellow tint never applies (stays white) */
::v-deep .v-alert--text::before {
  background-color: #FEF2CC !important;
  opacity: 1 !important;
}
.alert-description {
  color: var(--light-yellow);
  z-index: 0;
}
.spot-chip {
  background-color: #FEF2CC !important;
  color: var(--light-yellow-500) !important;
}
.compact-time-picker >>> .v-time-picker-title__time {
  font-size: 36px !important;
  height: 48px !important;
}
.compact-time-picker >>> .v-time-picker-title__time .v-picker__title__btn,
.compact-time-picker >>> .v-time-picker-title__time span {
  font-size: 36px !important;
  height: 48px !important;
}
/* Datos generales: las etiquetas hacen wrap en vez de truncarse (Vuetify las trunca por defecto) */
.pe-general-fields .v-list-item__content > .v-list-item__title {
  white-space: normal;
  line-height: 1.2;
}
</style>